module.exports = __webpack_public_path__ + "in.452060e50ae43c1b16d9.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/1x1/in.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/1x1/in.svg
// module chunks = styles